import * as React from "react";
import { SVGProps } from "react";
export function InboxOpenIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={18}
      height={18}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g
        clipPath="url(#inbox-open_svg__a)"
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M16.718 7.714v8.358a1.286 1.286 0 0 1-1.286 1.285H2.575a1.286 1.286 0 0 1-1.286-1.285V7.713" />
        <path d="M1.29 8.691 9.002 13.5l7.715-4.809M3.219 6.429v-4.5A1.286 1.286 0 0 1 4.504.643h9a1.286 1.286 0 0 1 1.286 1.286v4.5M7.078 4.5h3.857M7.078 7.714h3.857" />
      </g>
      <defs>
        <clipPath id="inbox-open_svg__a">
          <path fill="#fff" d="M0 0h18v18H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
